/** Get Notifications data */

export const SEND_CONFIRM_CODE = 'SEND_CONFIRM_CODE';

export const SEND_CONFIRM_CODE_SUCCESSFUL = 'SEND_CONFIRM_CODE_SUCCESSFUL';

export const SEND_CONFIRM_CODE_ERROR = 'SEND_CONFIRM_CODE_ERROR';

export const SEND_CONFIRM_CODE_RESEND = 'SEND_CONFIRM_CODE_RESEND';
